import styled from "styled-components";
import { COLORS } from "../../../values/colors";

export const HeroBanner = styled.div`
  width: min(1200px, calc(100% - 3rem));
  box-sizing: border-box;
  margin: 8rem auto 3rem;
  padding: 3rem;
  border: 1px solid rgba(181, 115, 76, 0.45);
  border-radius: 2rem;
  background:
    radial-gradient(circle at top left, rgba(181, 115, 76, 0.28), transparent 34%),
    linear-gradient(135deg, rgba(15, 15, 15, 0.98), rgba(10, 10, 10, 0.94));
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.35);

  @media (max-width: 768px) {
    width: calc(100% - 2rem);
    margin-top: 6rem;
    padding: 2rem 1.25rem;
  }
`;

export const Eyebrow = styled.p`
  margin: 0 0 0.75rem;
  color: ${COLORS.apronBrown};
  text-transform: uppercase;
  letter-spacing: 0.18rem;
  font-size: 0.85rem;
`;

export const HeroTitle = styled.h1`
  margin: 0;
  font-size: clamp(2.25rem, 4vw, 4.25rem);
  color: ${COLORS.white};
`;

export const HeroText = styled.p`
  max-width: 42rem;
  margin: 1rem 0 0;
  color: rgba(255, 255, 255, 0.82);
  line-height: 1.7;
  font-size: 1.05rem;
`;

export const ContentGrid = styled.div`
  width: min(1200px, calc(100% - 3rem));
  margin: 0 auto 5rem;
  display: grid;
  gap: 1.5rem;

  @media (max-width: 960px) {
    width: calc(100% - 2rem);
  }
`;

export const TwoColumnGrid = styled.div`
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 1.5rem;
  align-items: stretch;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.section`
  background: linear-gradient(180deg, rgba(19, 19, 19, 0.98), rgba(12, 12, 12, 0.95));
  border: 1px solid rgba(181, 115, 76, 0.3);
  border-radius: 1.5rem;
  padding: 1.75rem;
  color: ${COLORS.white};
  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.24);
`;

export const ProfileHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.75rem;
`;

export const Avatar = styled.div`
  width: 4.75rem;
  height: 4.75rem;
  border-radius: 1.4rem;
  display: grid;
  place-items: center;
  background: linear-gradient(135deg, ${COLORS.apronBrown}, ${COLORS.apronBrownDark});
  color: ${COLORS.white};
  font-size: 1.45rem;
  font-weight: 700;
  text-transform: uppercase;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15);
`;

export const Label = styled.p`
  margin: 0 0 0.2rem;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.12rem;
  font-size: 0.75rem;
`;

export const Value = styled.p`
  margin: 0;
  font-size: 1.05rem;
  color: ${COLORS.white};
`;

export const StatGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const StatCard = styled.div`
  padding: 1rem 1.1rem;
  border-radius: 1rem;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
`;

export const HintText = styled.p`
  margin: 0;
  color: rgba(255, 255, 255, 0.72);
  line-height: 1.7;
`;

export const ActionsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.9rem;
  margin-top: 1.5rem;
`;

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.45rem 0.8rem;
  border-radius: 999px;
  background: rgba(181, 115, 76, 0.15);
  border: 1px solid rgba(181, 115, 76, 0.35);
  color: ${COLORS.creamWhite};
  font-size: 0.85rem;
`;

export const SectionStack = styled.div`
  display: grid;
  gap: 1rem;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const FormActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.9rem;
`;

export const InlineMessage = styled.p<{ $tone: "success" | "error" }>`
  margin: 0;
  padding: 0.9rem 1rem;
  border-radius: 1rem;
  line-height: 1.6;
  color: ${({ $tone }) => ($tone === "success" ? COLORS.creamWhite : "#ffd0d0")};
  background: ${({ $tone }) =>
    $tone === "success" ? "rgba(181, 115, 76, 0.12)" : "rgba(191, 68, 68, 0.12)"};
  border: 1px solid
    ${({ $tone }) => ($tone === "success" ? "rgba(181, 115, 76, 0.28)" : "rgba(191, 68, 68, 0.3)")};
`;
